import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/SEO";
import { Home } from "lucide-react";

export default function NotFound() {
  const [, setLocation] = useLocation();

  const handleGoHome = () => {
    setLocation("/");
  };

  return (
    <>
      <SEO 
        title="404 - Page Not Found | Ganji Drinks"
        description="The page you're looking for seems to have gone missing. Let's get you back to enjoying our traditional ragi drinks."
      />
      
      <div 
        className="min-h-screen flex items-center justify-center px-4"
        style={{ backgroundColor: "#F4E9D8" }}
      >
        <div className="text-center max-w-2xl mx-auto">
          {/* 404 Number with Brand Styling */}
          <div className="mb-8 relative">
            <div 
              className="text-9xl font-bold select-none"
              style={{ 
                color: "#4A2E1A",
                fontFamily: "'Permanent Marker', cursive",
                textShadow: "3px 3px 0px rgba(210, 139, 50, 0.3)"
              }}
            >
              404
            </div>
            
            {/* Decorative Element */}
            <div 
              className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-2 rounded-full"
              style={{ backgroundColor: "#D28B32" }}
            />
          </div>

          {/* Error Message */}
          <h1 
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ 
              color: "#4A2E1A",
              fontFamily: "'Permanent Marker', cursive" 
            }}
          >
            Oops! Page Not Found
          </h1>
          
          <p 
            className="text-lg md:text-xl mb-8 leading-relaxed"
            style={{ color: "#4A2E1A" }}
          >
            Looks like this page has been lost in the traditional recipe book! 
            Don't worry, our delicious Ganji drinks are still here waiting for you.
          </p>

          {/* Illustration Placeholder */}
          <div className="mb-8 relative">
            <div 
              className="w-48 h-48 mx-auto rounded-full flex items-center justify-center"
              style={{ 
                backgroundColor: "#D28B32",
                opacity: 0.1
              }}
            >
              <div 
                className="w-32 h-32 rounded-full flex items-center justify-center"
                style={{ 
                  backgroundColor: "#4A2E1A",
                  opacity: 0.1
                }}
              >
                <div 
                  className="text-4xl font-bold"
                  style={{ color: "#4A2E1A" }}
                >
                  ?
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-center items-center">
            <Button
              onClick={handleGoHome}
              className="px-8 py-3 font-bold text-lg border-2 transition-all hover:scale-105 active:scale-95"
              style={{
                backgroundColor: "#D28B32",
                color: "#F4E9D8",
                borderColor: "#4A2E1A",
                fontFamily: "'Permanent Marker', cursive",
                boxShadow: "4px 4px 0px #4A2E1A"
              }}
            >
              <Home className="mr-2" size={20} />
              Back to Home
            </Button>
          </div>

          {/* Fun Message */}
          <div 
            className="mt-12 p-4 rounded-lg"
            style={{ 
              backgroundColor: "#4A2E1A",
              opacity: 0.05
            }}
          >
            <p 
              className="text-sm italic"
              style={{ color: "#4A2E1A" }}
            >
              "Even the best traditional recipes sometimes get misplaced! 
              Let's find you something refreshing instead."
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
